export interface WeeklyEntry {
  id: string;
  day: string;
  date: string;
  title: string;
  summary: string;
  tag: string;
  heat: number;
}

export interface WeeklyArchive {
  id: string;
  label: string;
  range: string;
  intro: string;
  entries: WeeklyEntry[];
}

export const weeklyArchives: WeeklyArchive[] = [
  {
    id: "w37",
    label: "第 37 周",
    range: "09.02 - 09.08",
    intro: "这一周话题集中在群像综艺与剧组物料上，中段由音乐现场与红毯造型接力，周末被品牌联名收尾。",
    entries: [
      {
        id: "a1",
        day: "周一",
        date: "09-08",
        title: "群像综艺镜头分配引讨论",
        summary: "对比片段密集出现，讨论重心从节目内容延伸到出场节奏与上镜机会。",
        tag: "综艺",
        heat: 9820,
      },
      {
        id: "a2",
        day: "周二",
        date: "09-07",
        title: "新剧杀青路透合集上线",
        summary: "按时序整理的造型变化成为本周被收藏最多的一份清单。",
        tag: "剧组",
        heat: 8640,
      },
      {
        id: "a3",
        day: "周三",
        date: "09-06",
        title: "巡演改编编曲登上热榜",
        summary: "现场版速度与低频的调整，引发了关于编曲方向的持续讨论。",
        tag: "音乐",
        heat: 7910,
      },
      {
        id: "a4",
        day: "周四",
        date: "09-05",
        title: "红毯造型盘点成焦点",
        summary: "按配色划分的三类造型思路，被大量转发与引用。",
        tag: "时尚",
        heat: 6430,
      },
      {
        id: "a5",
        day: "周六",
        date: "09-03",
        title: "联名物料刷屏社区",
        summary: "三段式发布节奏配合社区二创，让话题热度持续多日不散。",
        tag: "品牌",
        heat: 4720,
      },
    ],
  },
  {
    id: "w36",
    label: "第 36 周",
    range: "08.26 - 09.01",
    intro: "上周的讨论更偏向制作端，从海报设计到商务合作，整体节奏平缓但信息密度较高。",
    entries: [
      {
        id: "b1",
        day: "周一",
        date: "09-01",
        title: "系列海报设计成话题",
        summary: "统一的构图骨架与配色逻辑被设计类账号集中拆解。",
        tag: "剧组",
        heat: 3980,
      },
      {
        id: "b2",
        day: "周三",
        date: "08-31",
        title: "本月商务合作全收录",
        summary: "按行业整理的官宣清单，覆盖时尚、数码与快消三个方向。",
        tag: "品牌",
        heat: 3260,
      },
      {
        id: "b3",
        day: "周四",
        date: "08-30",
        title: "应援现场组织流程被整理",
        summary: "从物料准备到散场收尾的完整流程，引发关于现场秩序的讨论。",
        tag: "互动",
        heat: 4110,
      },
      {
        id: "b4",
        day: "周六",
        date: "08-28",
        title: "剧集先导物料集中放出",
        summary: "多部待播剧在同一天释放物料，形成短时间的信息高峰。",
        tag: "剧组",
        heat: 5230,
      },
    ],
  },
  {
    id: "w35",
    label: "第 35 周",
    range: "08.19 - 08.25",
    intro: "更早一周的热度由音乐现场与粉丝互动撑起，综艺话题数量偏少但讨论更集中。",
    entries: [
      {
        id: "c1",
        day: "周一",
        date: "08-25",
        title: "音乐节阵容公布引发期待",
        summary: "阵容海报放出后，关于曲风搭配与出场顺序的讨论迅速升温。",
        tag: "音乐",
        heat: 6180,
      },
      {
        id: "c2",
        day: "周三",
        date: "08-23",
        title: "二创热潮带来二次传播",
        summary: "以现场片段为素材的二创作品，在一周内形成规模效应。",
        tag: "互动",
        heat: 4520,
      },
      {
        id: "c3",
        day: "周五",
        date: "08-21",
        title: "综艺录制路透零星流出",
        summary: "本季新节目的录制画面被零星拍到，嘉宾阵容因此提前曝光。",
        tag: "综艺",
        heat: 3890,
      },
    ],
  },
];